import React, { useState } from 'react';
import {
    Row,
    Col,
    Divider,
    Input,
    Typography,
    Form,
    Button,
    DatePicker,
    AutoComplete,
    Skeleton,
    Result,
    message,
    Select,
    Switch
} from 'antd';
import {
    FaSave
} from "react-icons/fa";
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../config/axios';
import rawProvince from '../../utils/province.json';
import ResetPassword from './components/ResetPassword';

export default function Edit() {

    const { id } = useParams();
    const [messageApi, contextHolder] = message.useMessage();
    const [result, setResult] = useState([]);
    const [form] = Form.useForm();
    const queryClient = useQueryClient();
    const user = useQuery({ queryKey: [`/api/users/${id}`] })

    const { mutate, isLoading } = useMutation({
        mutationFn: (data) => {
            axios
                .put(`/api/users/${id}`, data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'User has been updated.',
                        duration: 1,
                        onClose: () => queryClient.invalidateQueries([`/api/users/${id}`])
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Something went wrong please check you data or contact Admin.',
                    });
                })
        },
    });

    const onFinish = (values) => {
        mutate(values);
    }
    const handleDistrictSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.district.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const handleAmphoeSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.amphoe.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const handleProvinceSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.province.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const onSelect = info => {
        const splitTambon = info.split('/');
        form.setFieldsValue({
            sub_district: splitTambon[0],
            district: splitTambon[1],
            province: splitTambon[2],
            postalcode: splitTambon[3]
        })
    };

    if (user.isLoading) {
        return <Skeleton active />
    }

    if (user.errorisError) {
        return <Result status="error" title={user.error.message} />
    };

    // console.log("id: ", id);
    // console.log("user: ", user.data);
    // console.log("dayjs(customer.data.birth_date): ", dayjs(customer.data.birth_date).isValid());
    return (
        <div style={{
            background: '#fff',
        }}>
            {contextHolder}
            <Row justify='space-between' >
                <Col xs={24} md={12} >
                    <Typography.Title level={3}>
                        Edit Employee
                    </Typography.Title>
                </Col>
                <Divider />
                <Col xs={24}>
                    <Form
                        name="editUser"
                        layout="vertical"
                        form={form}
                        onFinish={onFinish}
                        initialValues={{
                            ...user.data,
                            birth_date: dayjs(user.data.birth_date).isValid() ? dayjs(user.data.birth_date) : null
                        }}
                    >
                        <Row>
                            <Col xs={24} md={16}>
                                <Row gutter={[8, 8]}>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="First Name (ภาษาไทย)"
                                            name="fname_th"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Last Name (ภาษาไทย)"
                                            name="lname_th"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="First Name (English)"
                                            name="fname_en"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Last Name (English)"
                                            name="lname_en"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Phone Number"
                                            name="phone"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Nick Name"
                                            name="nick_name"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Gender"
                                            name="gender"
                                        >
                                            <Select placeholder="Select gender">
                                                <Select.Option value="MALE">Male</Select.Option>
                                                <Select.Option value="FEMALE">Female</Select.Option>
                                                <Select.Option value="OTHER">Other</Select.Option>
                                            </Select>
                                        </Form.Item>

                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="ID Card"
                                            name="idcard"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Birthdate"
                                            name="birth_date"
                                        >
                                            <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Email"
                                            name="email"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24}>
                                        <Form.Item name="address" label="Adress">
                                            <Input.TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Subdistrict"
                                            name="sub_district"
                                        >
                                            <AutoComplete
                                                onSelect={onSelect}
                                                onSearch={handleDistrictSearch}
                                            >
                                                {result.map((tam) => (
                                                    <AutoComplete.Option key={tam} value={tam}>
                                                        {tam}
                                                    </AutoComplete.Option>
                                                ))}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="District"
                                            name="district"
                                        >
                                            <AutoComplete
                                                onSelect={onSelect}
                                                onSearch={handleAmphoeSearch}
                                            >
                                                {result.map((amp) => (
                                                    <AutoComplete.Option key={amp} value={amp}>
                                                        {amp}
                                                    </AutoComplete.Option>
                                                ))}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Province"
                                            name="province"
                                        >
                                            <AutoComplete
                                                onSelect={onSelect}
                                                onSearch={handleProvinceSearch}
                                            >
                                                {result.map((prov) => (
                                                    <AutoComplete.Option key={prov} value={prov}>
                                                        {prov}
                                                    </AutoComplete.Option>
                                                ))}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Postalcode"
                                            name="postalcode"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item label="Status" name="is_active" valuePropName="checked">
                                            <Switch checkedChildren="active" unCheckedChildren="inactive" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} >
                                        <Row justify="end">
                                            <Col>
                                                <Form.Item>
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        disabled={isLoading}
                                                        icon={<FaSave />}
                                                        style={{
                                                            textTransform: 'capitalize'
                                                        }}
                                                    >
                                                        save
                                                    </Button>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
            <ResetPassword user={user.data}/>
        </div>
    )
}
